import { Box, Divider, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import styles from "../devoteeService/devoteeService.module.scss";
import {
  CommonButton,
  formatAmount,
} from "./StyledComponents/StyledFields";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import {
  apiRequest,
  authService,
  catchErrorMessageHandler,
  getUserSelectedRole,
} from "../../infrastructure/backendService";
import apiPath from "../../config/apiPaths.json";
import constants from "../../config/constants.json";
import { isNil } from "lodash";
import { useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import { receiptListItemProps } from "../../infrastructure/GlobalContextProvider";
import ErrorPopup from "./ErrorPopup";
import { ClipLoader } from "react-spinners";
import { BounceLoader } from "react-spinners";
import ReactDOM from "react-dom";
import SuccessPopup from "../devotee/donation/successPopup";

interface FamilyMemberProps {
  id: number;
  name: string;
  relation: string;
  nakshatram: string;
  gothram: string;
  firstname: string;
  lastname: string;
}

const Receipt = () => {
  const componentRef = useRef(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [name, setName] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [adddress, setAdddress] = useState("");
  const [generatedDate, setRecieptGeneratedDate] = useState<any>(null);
  const [zipCode, setZipCode] = useState("");
  const [donationType, setDonationType] = useState("");
  const [checkNumber, setCheckNumber] = useState("");
  const [bankName, setBankName] = useState("");
  const [loading, setLoading] = useState<boolean>(true);
  const [familyData, setfamilyData] = useState<FamilyMemberProps[]>([]);
  const [listItems, setListItems] = useState<receiptListItemProps[]>([]);
  const [matchingDonationsInfo, setMatchingDonationsInfo] = useState<[]>([]);
  const [searchParam] = useSearchParams();
  const receiptID = searchParam.get("receiptID");
  const userID = searchParam.get("userID");
  const [payPalTransactionId, setPayPalTransactionId] = useState("");
  const showPaymentStatus = JSON.parse(sessionStorage.getItem("showPaymentStatus") || "false");
  const [showSuccessPopup, setShowSuccessPopup] = useState(showPaymentStatus);
  const [receiptMailed, setReceiptMailed] = useState(true);

  const hasManagerLevelRole = constants.showDashBoardForRoles.includes(
    getUserSelectedRole() || ""
  );

  useEffect(() => {
    window.scroll(0, 200)
    if (!isNil(receiptID)) {
      receiptReport();
    }
  }, [receiptID, userID]);

  const formatDate = (date: Date): string => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const year = date.getFullYear();

    // getMonth() returns month from 0-11. Add 1 to get 1-12
    // const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const month = monthNames[date.getMonth()];

    // getDate() returns day of the month from 1-31
    const day = date.getDate().toString().padStart(2, "0");

    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";

    // Convert hours to 12-hour format
    hours = hours % 12;
    // The hour '0' should be '12'
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const strHours = hours.toString().padStart(2, "0");

    // Construct the desired format: MM/DD/YYYY HH:MM:SS AM/PM
    return `${day} ${month}, ${year} ${strHours}:${minutes}:${seconds} ${ampm}`;
  };

  const getDateTimeWithoutTimezone = (dateTimeString: string) => {
    // Remove the time zone offset using regular expressions
    const dateTimeWithoutTimeZone = dateTimeString?.replace(
      /(-|\+)\d{2}:\d{2}$/,
      ""
    );
    return new Date(dateTimeWithoutTimeZone);
  };

  const receiptReport = () => {
    apiRequest({
      method: "GET",
      // endpoint: apiPath.receiptGeneration,
      endpoint: authService.isAuthenticated()
        ? apiPath.receiptGeneration
        : apiPath.receiptUnRegGeneration,
      includeToken: !authService.isAuthenticated() ? false : true,
      params: {
        receiptsId: receiptID,
        username: userID,
      },
    })
      .then((res) => {
        setfamilyData(res.data.familyMembers);
        setListItems(res.data.itemsList);
        setName(`${res.data.devotee.firstname} ${res.data.devotee.lastname}`);
        setAdddress(res.data.devotee.address);
        setRecieptGeneratedDate(
          formatDate(
            getDateTimeWithoutTimezone(
              res.data.modeOfPayment.transactionDate
            )
          )
        );
        setState(res.data.devotee.state);
        setCity(res.data.devotee.city);
        setCountry(res.data.devotee.country);
        setDonationType(res.data.modeOfPayment.donationType);
        setCheckNumber(res.data.modeOfPayment.checkNumber);
        setBankName(res.data.modeOfPayment.bankName);
        setZipCode(res.data.devotee.zipcode);
        setMatchingDonationsInfo(res.data.itemsList);
        setPayPalTransactionId(res.data.modeOfPayment.payPalTransactionId);
        setLoading(false);
        setReceiptMailed(res.data.receiptMailed);
      })
      .catch((err) => {
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };
  const payMentInfo = () => {
    return (
      <>
        <Box className={styles.singlePaymentLine}>
          <Box className={styles.singleDetails}>
            <Typography className={styles.singlePay}>Total</Typography>
            <Typography className={styles.singlePaydetail}>
              {formatAmount(totalDonationAmount)}
            </Typography>
          </Box>

          <Divider className={styles.horizontalLine} />
        </Box>
        <Box className={styles.singlePaymentLine}>
          <Box className={styles.singleDetails}>
            <Typography className={styles.singlePay}>
              Mode of Payment
            </Typography>
            <Typography className={styles.singlePaydetail}>
              {donationType}
            </Typography>
          </Box>
          <Divider className={styles.horizontalLine} />
        </Box>
        {donationType == "PayPal" && payPalTransactionId && (
          <Typography
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "5px",
            }}
            className={styles.singlePaydetail}
          >
            Transaction ID : {payPalTransactionId}
          </Typography>
        )}
        <Box className={styles.singlePaymentLine}>
          {!isNil(checkNumber) && donationType !== "Credit Card" && (
            <Box className={styles.singlePaymentLine}>
              <Box className={styles.singleDetails}>
                <Typography className={styles.singlePay}>
                  Check Number
                </Typography>
                <Typography className={styles.singlePaydetail}>
                  {checkNumber}
                </Typography>
              </Box>
              <Divider className={styles.horizontalLine} />
            </Box>
          )}
          {/* <Divider className={styles.horizontalLine} /> */}
        </Box>
        {!isNil(bankName) && donationType !== "Credit Card" && (
          <Box className={styles.singlePaymentLine}>
            <Box className={styles.singleDetails}>
              <Typography className={styles.singlePay}>Bank Name</Typography>
              <Typography className={styles.singlePaydetail}>
                {bankName}
              </Typography>
            </Box>
          </Box>
        )}
      </>
    );
  };

  const userDetails = () => {
    return (
      <Box className={styles.userConatiner}>
        <div className={styles.receeiptNoAndDate}>
          <Typography className={styles.rightData}>
            <span className={styles.leftData}>Receipt No:</span> {receiptID}
          </Typography>
          <Typography className={styles.rightData}>
            <span className={styles.leftData}>Date:</span> {generatedDate}
          </Typography>
        </div>
        <Typography className={styles.rightData}>
          <span className={styles.leftData}>Name:</span> {name}
        </Typography>
        <Typography className={styles.rightData}>
          <span className={styles.leftData}>Address:</span> {adddress}, {"   "}
          {city}, {"   "}
          {state}
          {" - "}
          {zipCode}
          {"  "}
          {country}
        </Typography>
      </Box>
    );
  };
  const familyMemberTable = () => {
    return (
      <>
        {familyData.length > 0 ? (
          <div style={{ overflowY: "auto" }}>
            <table className={styles.tableContainer}>
              <thead>
                <tr className={styles.headerTableRow}>
                  <th className={styles.tableHorizontal}>Gothram</th>
                  <th className={styles.tableHorizontal}>Nakshatram</th>
                  <th className={styles.tableHorizontal}>Name</th>
                  <th className={styles.tableHorizontal}>Relationship</th>
                </tr>
              </thead>
              <tbody className={styles.tableBody} id="familyMembers">
                {familyData.map((row) => (
                  <tr key={row.id} className={styles.tableRow}>
                    <td
                      className={styles.tableDiagonal}
                      style={{
                        fontWeight: 400,
                        color: "#000",
                        textAlign: "left",
                      }}
                    >
                      {!isNil(row.gothram) ? row.gothram : "-"}
                    </td>
                    <td
                      className={styles.tableDiagonal}
                      style={{
                        color: "#000",
                        fontWeight: 400,
                        textAlign: "left",
                      }}
                    >
                      {!isNil(row.nakshatram) ? row.nakshatram : "-"}
                    </td>
                    <td
                      className={styles.tableDiagonal}
                      style={{
                        color: "#000",
                        fontWeight: 400,
                        textAlign: "left",
                      }}
                    >
                      {row.firstname} {row.lastname}
                    </td>
                    <td
                      className={styles.tableDiagonal}
                      style={{
                        color: "#000",
                        fontWeight: 400,
                        textAlign: "left",
                      }}
                    >
                      {row.relation}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          ""
        )}
      </>
    );
  };

  const renderPrintComponent = () => {
    return (
      <Box className={styles.DownloadReceiptConatiner}>
        <Box className={styles.headerConatiner}>{HeaderDonation()}</Box>
        <Box className={styles.userDetails}>{userDetails()}</Box>

        <Box className={styles.tableContainerList}>
          {familyData.length > 0 ? (
            <Typography className={styles.header}>Family Members</Typography>
          ) : (
            ""
          )}
          {familyMemberTable()}
        </Box>

        <Box className={styles.tableContainerList}>
          <Typography className={styles.header}>List of Items</Typography>
          {listItemTable()}
        </Box>
        <Box className={styles.paymenyDetails}>{payMentInfo()}</Box>
      </Box>
    );
  };

  const handleDownload = () => {

    // Create a hidden div element
    const container = document.createElement("div");
    document.body.appendChild(container);

    // Render the component into the hidden div
    ReactDOM.render(renderPrintComponent(), container);

    const pdf = new jsPDF("p", "mm", "a4", true);

    // Use html2canvas to capture the content as an image
    html2canvas(container).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
      const imgX = (pdfWidth - imgWidth * ratio) / 2;
      const imgY = 30;

      // Add the image to the PDF
      pdf.addImage(
      imgData,
      "PNG",
      imgX,
      imgY,
      imgWidth * ratio,
      imgHeight * ratio
      );

      // Download the PDF
      pdf.save(`receipt_${receiptID}.pdf`);
      container.remove();
    });
  };

  const handlePrint = () => {
    window.scroll(0, 200);
    setLoading(true);

    // Create a hidden div element
    const container = document.createElement("div");
    document.body.appendChild(container);

    // Render the component into the hidden div
    ReactDOM.render(renderPrintComponent(), container);

    const pdf = new jsPDF("p", "mm", "a4", true);

    // Use html2canvas to capture the content as an image
    html2canvas(container)
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/png");

        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const imgWidth = canvas.width;
        const imgHeight = canvas.height;
        const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
        const imgX = (pdfWidth - imgWidth * ratio) / 2;
        const imgY = 30;

        // Add the image to the PDF
        pdf.addImage(
        imgData,
        "PNG",
        imgX,
        imgY,
        imgWidth * ratio,
        imgHeight * ratio
        );

        // Open print preview
        window.open(pdf.output("bloburl"), "_blank");

        setLoading(false); // Set loading to false after PDF generation
        container.remove();
      })
      .catch((error) => {
        console.error("Error occurred during PDF generation:", error);
        setLoading(false); // Set loading to false if an error occurs
      });
  };

  const HeaderDonation = (): React.ReactElement => {
    return (
      <Box className={styles.Header}>
        <div>
          <img src="/images/TempleOldLogo.png" className={styles.HeaderImage} />
          <Typography className={styles.TempleNameData}>
            Shiva -Vishnu Temple
          </Typography>
        </div>
        <Box className={styles.TempleAddress}>
          <Typography className={styles.TempleAddressData}>
            <span style={{ fontWeight: "bold", letterSpacing: "1px" }}>
              Hindu Community and Cultural Center
            </span>
            <br />A Registered Non-Profit Organization
            <br />
            Tax ID: 94-2427126, Inc: D08215891232,
            <br /> Arrowhead Ave, Livermore, CA 94551 <br />
            Tel: (925) 449-6255, Fax: (925) 455-0404.
          </Typography>
        </Box>
      </Box>
    );
  };

  const listItemTable = () => {
    return (
      <>
        <div style={{ overflowY: "auto" }}>
          <table className={styles.tableContainer}>
            <thead>
              <tr className={styles.headerTableRow}>
                <th className={styles.tableHorizontal}>Ref No</th>
                <th className={styles.tableHorizontal}>Type</th>
                <th className={styles.tableHorizontal}>Pooja/Hall Name</th>
                <th className={styles.tableHorizontal}>Priest Name</th>
                <th className={styles.tableHorizontal}>Donation Purpose</th>
                <th className={styles.tableHorizontal}>Description</th>
                <th
                  className={styles.tableHorizontal}
                  style={{ textAlign: "right" }}
                >
                  Amount
                </th>
                <th
                  className={styles.tableHorizontal}
                  style={{ textAlign: "right" }}
                >
                  Tangible Amount
                </th>
              </tr>
            </thead>
            <tbody className={styles.tableBody} id="listOfItems">
              {listItems.map((row, id) => (
                <>
                  <tr key={id} className={styles.tableRow}>
                    <td
                      className={styles.tableDiagonal}
                      style={{
                        color: "#000",
                        fontWeight: 400,
                        textAlign: "left",
                      }}
                    >
                      {isNil(row.referenceNumber) ? "-" : row.referenceNumber}
                    </td>
                    <td
                      className={styles.tableDiagonal}
                      style={{
                        color: "#000",
                        fontWeight: 400,
                        textAlign: "left",
                      }}
                    >
                      {row.type}
                    </td>

                    <td
                      className={styles.tableDiagonal}
                      style={{
                        color: "#000",
                        fontWeight: 400,
                        textAlign: "left",
                      }}
                    >
                      {row.poojaTitle}
                    </td>
                    <td
                      className={styles.tableDiagonal}
                      style={{
                        color: "#000",
                        fontWeight: 400,
                        textAlign: "left",
                      }}
                    >
                      {row.priestName}
                    </td>
                    <td
                      className={styles.tableDiagonal}
                      style={{
                        fontWeight: 400,
                        color: "#000",
                        textAlign: "left",
                      }}
                    >
                      {row.donationPurpose}
                    </td>
                    <td
                      className={styles.tableDiagonal}
                      style={{
                        fontWeight: 400,
                        color: "#000",
                        textAlign: "left",
                      }}
                    >
                      {/* {row.description} */}
                      {isNil(row.poojaDate) && isNil(row.location) ? (
                        <>{row.description}</>
                      ) : (
                        <>
                          <span style={{ fontWeight: "bold" }}>Location:</span>{" "}
                          {row.location},{" "}
                          <span style={{ fontWeight: "bold" }}>
                            Pooja Date:
                          </span>
                          {" "}{row.poojaDate}
                          <br />
                          {isNil(row.description) ? (
                            ""
                          ) : (
                            <span>{row.description}</span>
                          )}
                          <br />
                        </>
                      )}
                      {isNil(row.vastraCategory) &&
                      isNil(row.vastraExchange) ? (
                        ""
                      ) : (
                        <>
                          {isNil(row.vastraTag) ? (
                            ""
                          ) : (
                            <span>
                              <span
                                style={{
                                  fontWeight: "bold",
                                  paddingLeft: "5px",
                                }}
                              >
                                , Vastra Tag:{" "}
                              </span>
                              {row.vastraTag}
                            </span>
                          )}
                          <br />
                          {isNil(row.vigrahaType) ? (
                            ""
                          ) : (
                            <span>
                              <span style={{ fontWeight: "bold" }}>
                                Vigraha Type:{" "}
                              </span>
                              {row.vigrahaType}
                            </span>
                          )}
                          <br />
                          <span style={{ fontWeight: "bold" }}>
                            Vastra Category{" "}
                          </span>
                          : {row.vastraCategory},{" "}
                          <span style={{ fontWeight: "bold" }}>
                            Vastra Exchange{" "}
                          </span>
                          : {row.vastraExchange}
                        </>
                      )}
                      {row.dateOfAdornmentOrHallBookedDate && (
                        <>
                          <br />
                          <span style={{ fontWeight: "bold" }}>Date&nbsp;</span>
                          : {row.dateOfAdornmentOrHallBookedDate}
                        </>
                      )}
                    </td>
                    <td className={styles.tableDiagonalAmount}>
                      {formatAmount(row.donationAmount)}
                    </td>
                    <td className={styles.tableDiagonalAmount}>
                      {!isNil(row.tangibleAmount)
                        ? formatAmount(row.tangibleAmount)
                        : "-"}
                    </td>
                  </tr>
                  {MatchinDonationsInfo(row.referenceNumber)}
                </>
              ))}
              <tr className={styles.footerTableRow}>
                <td className={styles.footerTotalText} colSpan={6}>
                  Total:
                </td>
                <td className={styles.footerText}>
                  {formatAmount(totalDonationAmount)}
                </td>
                <td className={styles.footerText}>
                  {formatAmount(totalTangibleAmount)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </>
    );
  };
  const totalDonationAmount = listItems.reduce(
    (total, row) => total + row.donationAmount,
    0
  );

  const totalTangibleAmount = listItems.reduce(
    (total, row) => total + row.tangibleAmount,
    0
  );
  const MatchinDonationsInfo = (referenceNumber: any) => {
    // Assuming matchingDonationsInfo is your list of items
    let triggerPointsSet = new Set(); // Initialize a set to store trigger points

    return (
      <div>
        <table className={styles.tableContainer}>
          <tbody>
            {(!isNil(matchingDonationsInfo) ? matchingDonationsInfo : []).map(
              (item: any) => {
                // Check if the trigger point is already displayed
                if (!triggerPointsSet.has(item.triggerPoint)) {
                  triggerPointsSet.add(item.triggerPoint); // Add trigger point to set

                  if (referenceNumber === item.referenceNumber)
                    return (
                      <React.Fragment key={item.triggerPoint}>
                        <tr>
                          <Typography
                            sx={{
                              color: "#000",
                              fontFamily: "Lato",
                              fontSize: "16px",
                              fontStyle: "normal",
                              fontWeight: 600,
                            }}
                          >
                            {item.triggerPoint}
                          </Typography>
                        </tr>
                        {/* Render rest of the rows */}
                        {(
                          item.matchingDonationsAndDonorAdvisoryFundsProjectionList ||
                          []
                        ).map((val: any) => {
                          if (referenceNumber === item.referenceNumber)
                            return (
                              <tr
                                key={val.username}
                                className={styles.tableRow}
                              >
                                <td className={styles.tableDiagonal}>
                                  {val.name} ({val.username})
                                </td>
                                <td
                                  className={styles.tableDiagonal}
                                  style={{
                                    textAlign: "right",
                                    paddingRight: "10px",
                                  }}
                                >
                                  {formatAmount(val.amount)}
                                </td>
                              </tr>
                            );
                        })}
                      </React.Fragment>
                    );
                } else {
                  // Trigger point already displayed, render only the rows
                  return (
                    item.matchingDonationsAndDonorAdvisoryFundsProjectionList ||
                    []
                  ).map((val: any) => (
                    <tr key={val.username} className={styles.tableRow}>
                      <td className={styles.tableDiagonal}>
                        {val.name} ({val.username})
                      </td>
                      <td
                        className={styles.tableDiagonal}
                        style={{ textAlign: "right", paddingRight: "10px" }}
                      >
                        {formatAmount(val.amount)}
                      </td>
                    </tr>
                  ));
                }
              }
            )}
          </tbody>
        </table>
      </div>
    );
  };

  const renderSuccessPopup = () => {
    setTimeout(() => {
      sessionStorage.removeItem("showPaymentStatus");
    }, 100);
    return (
      <>
        <SuccessPopup
          showMessage="The payment has been done successfully"
          headerMessage="Payment Successful!"
          isOpen={true}
          setIsOpen={setIsOpen}
          onCreditClick={() => {}}
          warningMessage={`${
            !receiptMailed
              ? hasManagerLevelRole
                ? "Unable to share receipt with Devotee. Devotee's email ID is invalid/missing."
                : "Unable to share receipt. Your email ID is invalid/missing." 
              : ""
          }`}
        />
      </>
    );
  };

  return (
    <>
      {loading ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "300px",
          }}
        >
          <BounceLoader color="#22A699" loading={loading} size={45} />
          <span
            style={{
              marginLeft: "8px",
              fontSize: "15px",
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
            }}
          >
            Please wait...
          </span>
        </div>
      ) : (
        <div>
          <Box className={styles.ReceiptConatiner} ref={componentRef}>
            <Box className={styles.headerConatiner}>{HeaderDonation()}</Box>
            <Box className={styles.userDetails}>{userDetails()}</Box>

            <Box className={styles.tableContainerList}>
              {familyData.length > 0 ? (
                <Typography className={styles.header}>Family Members</Typography>
              ) : (
                ""
              )}
              {familyMemberTable()}
            </Box>

            <Box className={styles.tableContainerList}>
              <Typography className={styles.header}>List of Items</Typography>
              {listItemTable()}
            </Box>
            <Box className={styles.paymenyDetails}>{payMentInfo()}</Box>
          </Box>
          <Box
            className={styles.Button}
            sx={{ marginLeft: "20px", marginTop: "16px" }}
          >
            <CommonButton onClick={handlePrint} disabled={loading}>
              {loading ? (
                <>
                  <ClipLoader color="#fff" loading={loading} size={15} />
                  <span
                    style={{
                      marginLeft: "8px",
                      fontSize: "15px",
                      textAlign: "center",
                    }}
                  >
                    Loading...
                  </span>
                </>
              ) : (
                "Print"
              )}
            </CommonButton>
            <CommonButton onClick={handleDownload} sx={{ marginLeft: "16px" }}>
              Download
            </CommonButton>
          </Box>
        </div>
      )}
      {!loading && showSuccessPopup && renderSuccessPopup()}
    </>
  );
};

export default Receipt;
